export const METADATA_FILTER_DATE_FORMAT = 'yyyy-MM-dd'
